import { IUserContextData } from "../interfaces/UserContext/IUserContextData";
import { IUserContextToken } from "../interfaces/UserContext/IUserContextToken";
import { User } from "../models/User";
import { SpecialtyType } from "../models/SpecialtyType";

export const parseUserContextToken = (
  token: string | null | undefined,
): IUserContextToken | null => {
  try {
    if (!token) return null;
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    // Replace URL-safe base64 characters with standard base64 characters
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    // Decode base64 string using browser-native atob()
    const decoded = atob(base64);
    return JSON.parse(decoded);
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const parseUserContextData = (
  token: string | null,
): IUserContextData | null => {
  try {
    const userContextTokenParsed = parseUserContextToken(token);
    return (
      userContextTokenParsed &&
      JSON.parse(userContextTokenParsed["user-context"])
    );
  } catch (error) {
    console.error(error);
  }
  return null;
};

// Function to get the specialtyType for the current user
export const getLoggedInUserSpecialtyType = (
  user: User | undefined,
  currentSite?: { specialtyType?: SpecialtyType } | null,
): SpecialtyType | undefined => {
  // If currentSite is available, use its specialtyType
  if (currentSite?.specialtyType) {
    return currentSite.specialtyType;
  }

  // Fallback to the first active site assignment's specialtyType
  return user?.siteAssignments?.find(
    (siteAssignment) =>
      siteAssignment.site?.specialtyType && siteAssignment.isActive,
  )?.site?.specialtyType;
};
